
export enum EStatuses {
	AWAIT_VERIFICATION = 'awaiting_verification',
	DRAFT = 'draft',
	IN_PROGRESS = 'in_progress',
	PUBLISHED = 'published',
	VERIFIED = 'verified',
}
